module.exports = __webpack_public_path__ + "img/Alpiq_120X35.37ce3bd4.png";